<template>
  <div class="device-slogan">
    <v-skeleton-loader v-if="!props.slogan" type="list-item" min-width="100%" />
    <div v-else>
      <div v-if="!isEditing">
        {{ localSlogan }}
        <v-icon class="edit-slogan-btn" color="secondary" @click="isEditing = true">
          mdi-pencil-circle-outline
        </v-icon>
      </div>
      <div v-else>
        <v-form @submit.prevent="saveSlogan">
          <v-text-field
            v-model="localSlogan"
            autofocus
            density="compact"
            :hide-details="true"
            variant="solo"
            maxlength="25"
            :aria-label="t('components.devices.editSlogan.editButton')"
            @blur="saveSlogan"
            @keydown.enter="saveSlogan"
          />
        </v-form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { API } from "@/plugins/api";
import { useApplicationStore } from "@/store/application";

const { t } = useI18n();
const appStore = useApplicationStore();
const props = defineProps<{ deviceId: string; siteId: string; slogan: string | undefined }>();
const api = inject<API>("api");

const isEditing = ref(false);
const localSlogan = ref(props.slogan);

watch(
  () => props.slogan,
  (newSlogan) => {
    localSlogan.value = newSlogan;
  },
);

const saveSlogan = async () => {
  if (!localSlogan.value) return;
  try {
    await api?.device.updateDeviceConfig(props.siteId, props.deviceId, {
      signature: { deviceSlogan: localSlogan.value },
    });
    isEditing.value = false;
    appStore.notifyUser({
      message: t("components.devices.editSlogan.successMessage"),
      type: "success",
    });
  } catch (error) {
    console.error(error);
    appStore.notifyUser({
      message: t("components.devices.editSlogan.errorMessage"),
      type: "error",
    });
  }
};
</script>

<style scoped>
.device-slogan {
  position: relative;
}
</style>
